import { render, staticRenderFns } from "./ActionActive.vue?vue&type=template&id=99ac2f48"
import script from "./ActionActive.vue?vue&type=script&lang=js"
export * from "./ActionActive.vue?vue&type=script&lang=js"
import style0 from "./ActionActive.vue?vue&type=style&index=0&id=99ac2f48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports